import type {
  AppShellSidebarNavGroup,
  AppShellSidebarNavItem,
} from '@/components/layout/dashboard/app-shell-sidebar-nav.types';
import type { SettingPageTabs } from '@/app/(authenticated)/(dashboard)/settings/constants';
import { translateSafe } from '@/utils/translations';
import {
  Bell,
  Building2,
  CircleUser,
  Filter,
  FolderKanban,
  Plug,
  Share2,
  Users,
} from 'lucide-react';

export const SETTINGS_SIDEBAR_ADMIN_GROUP_TITLE = 'Admin';
export const SETTINGS_SIDEBAR_WORKSPACE_GROUP_TITLE = 'Workspace';
export const SETTINGS_SIDEBAR_ACCOUNT_GROUP_TITLE = 'Account';

const SETTINGS_SIDEBAR_ADMIN_ITEMS: AppShellSidebarNavItem<SettingPageTabs>[] = [
  {
    id: 'members',
    title: translateSafe('settingsPageTabs', 'members'),
    icon: Users,
  },
  {
    id: 'organizations',
    title: translateSafe('settingsPageTabs', 'organizations'),
    icon: Building2,
  },
  {
    id: 'projects',
    title: translateSafe('settingsPageTabs', 'projects'),
    icon: FolderKanban,
  },
  {
    id: 'filters',
    title: translateSafe('settingsPageTabs', 'filters'),
    icon: Filter,
  },
];

const SETTINGS_SIDEBAR_WORKSPACE_ITEMS: AppShellSidebarNavItem<SettingPageTabs>[] = [
  {
    id: 'shared_pages',
    title: translateSafe('settingsPageTabs', 'shared_pages'),
    icon: Share2,
  },
  {
    id: 'alert_settings',
    title: translateSafe('settingsPageTabs', 'alert_settings'),
    icon: Bell,
  },
  {
    id: 'integration',
    title: translateSafe('settingsPageTabs', 'integration'),
    icon: Plug,
  },
];

const SETTINGS_SIDEBAR_ACCOUNT_ITEMS: AppShellSidebarNavItem<SettingPageTabs>[] = [
  {
    id: 'account',
    title: translateSafe('settingsPageTabs', 'account'),
    icon: CircleUser,
  },
];

export const SETTINGS_SIDEBAR_GROUPS: AppShellSidebarNavGroup<SettingPageTabs>[] = [
  {
    title: SETTINGS_SIDEBAR_ADMIN_GROUP_TITLE,
    items: SETTINGS_SIDEBAR_ADMIN_ITEMS,
  },
  {
    title: SETTINGS_SIDEBAR_WORKSPACE_GROUP_TITLE,
    items: SETTINGS_SIDEBAR_WORKSPACE_ITEMS,
  },
  {
    title: SETTINGS_SIDEBAR_ACCOUNT_GROUP_TITLE,
    items: SETTINGS_SIDEBAR_ACCOUNT_ITEMS,
  },
];

export const SETTINGS_SIDEBAR_ITEMS: AppShellSidebarNavItem<SettingPageTabs>[] =
  SETTINGS_SIDEBAR_GROUPS.flatMap((group) => group.items);

export function getSettingsSectionTitle(section: SettingPageTabs): string {
  return SETTINGS_SIDEBAR_ITEMS.find((item) => item.id === section)?.title ?? '';
}

export function getSettingsSectionDescription(section: SettingPageTabs): string {
  return SETTINGS_SIDEBAR_ITEMS.find((item) => item.id === section)?.description ?? '';
}

export const SETTINGS_SECTIONS_WITH_TITLE_HEADER: ReadonlySet<SettingPageTabs> = new Set(['account', 'integration']);
